import { JSX } from "react";
import { BasicRecord } from "./basicRecord";
import { BasicTable } from "./BasicTable";
import { SummaryResultNetworkType, SummaryResultType } from "./enumerations";

interface SpecialtyProps {
  providersEndpointFunc: (networkType: SummaryResultNetworkType, resultType: SummaryResultType, key: number) => string;
  records: BasicRecord[];
}

const Specialty = (props: SpecialtyProps): JSX.Element => <BasicTable {...props} records={props.records} tableName="# of Specialties" />;

export { Specialty };
